import RailsResource from "./rails-resource";

export default new class extends RailsResource {
  constructor() {
    super({
      url: '/admin',
      resource: 'frequency-values',
      ajaxLoader: true
    });
  }

  updateValues(id, data) {
    return this.post(`${this.url}/${this.resource}/${id}/update-values.json`, true, data);
  }
}